import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FormState {
   disbursement: Date | null;
   value: number | null;
   period: number | null;
   frequency: string | null;
   description: string | null;
   bank: string | null;
   account: string | null;
   typeAccount: string | null;
}

interface LoanRequestState {
   form: FormState;
   totalInvestment: number;
   totalCredit: number;
}

const initialState: LoanRequestState = {
   form: {
      disbursement: null,
      value: null,
      period: null,
      frequency: null,
      description: null,
      bank: null,
      account: null,
      typeAccount: null,
   },
   totalInvestment: 0,
   totalCredit: 0,
};

const loanRequestSlice = createSlice({
   name: 'loanRequest',
   initialState,
   reducers: {
      setForm: (state, action: PayloadAction<FormState>) => {
         state.form = action.payload;
      },
      setTotales: (
         state,
         action: PayloadAction<{ totalInvestment: number; totalCredit: number }>
      ) => {
         state.totalInvestment = action.payload.totalInvestment;
         state.totalCredit = action.payload.totalCredit;
      },
      setDefault: (state) => {
         state.form = { ...initialState.form };
         state.totalInvestment = 0;
         state.totalCredit = 0;
      },
   },
});

export const { setForm, setTotales, setDefault } = loanRequestSlice.actions;
export default loanRequestSlice.reducer;
